var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyClose = function SvgHappyClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h16v16H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.854 9.814a.641.641 0 0 0 .905.906l3.952-3.952a.1.1 0 0 1 .076-.031q.044 0 .075.031l3.952 3.952a.64.64 0 1 0 .905-.905L6.768 5.862a.1.1 0 0 1-.031-.075q0-.045.031-.076L10.72 1.76a.64.64 0 1 0-.906-.905l-3.952 3.95a.1.1 0 0 1-.075.032.1.1 0 0 1-.076-.032L1.76.855a.64.64 0 0 0-.905.904l3.951 3.952q.031.031.032.076a.1.1 0 0 1-.032.075L.855 9.814z"
  }))));
};
export default SvgHappyClose;